module.exports = __webpack_public_path__ + "img/sortmove-for-sale-2.c75c0fe2.png";